/* eslint no-console:0 */
// This is the entrypoint for the `django` child theme. The files
// imported here will be included on every page of the django website.
//
// To reference this file, add <%= javascript_pack_tag 'django' %> to the appropriate
// layout file, like frontend/django/layouts/application.haml

import 'shared/assets/css'
import 'django/components/header/header'
import 'django/components/footer/footer'
import 'django/components/newsletter_signup/newsletter_signup'
import 'django/components/event_inquiry/event_inquiry'
import 'django/components/popup_notification/popup_notification'
import 'django/components/reservations_cta/reservations_cta'
import 'shared/components'
import 'shared/assets/javascript'
import './css'
import './javascript'
